import { defineStore } from 'pinia';
import type { Buerge } from '@/shared/Buergen/types';
import { useNutzerStore } from '@/shared/Nutzer/useNutzerStore';
import { Vertragsart } from '@/types/Partner.ts';

import { Gevo, GevoKanal } from '@/shared/AvalKonfigurator/Kommunikation.ts';
import { useSharedApi } from '@/shared/api/useSharedApi.ts';

interface StoreState {
  buergen: Map<string, Buerge>;
}

const api = useSharedApi().sharedAvalPartnerKonfigurator;

export const useBuergenStore = defineStore('BürgenStore', {
  state: (): StoreState => ({
    buergen: new Map<string, Buerge>(),
  }),

  actions: {
    async fuegeBuergeHinzu(buerge: Buerge) {
      if (!this.buergen.has(buerge.unternehmenId)) {
        if (buerge.vertragsart === Vertragsart.REGULAR) {
          const gevo = await api.holeBuergenKommunikation(Gevo.VER_EST, buerge.unternehmenId);
          buerge.erlaubtAuftraege = gevo.gevoKanalDto !== GevoKanal.KVER;
        }

        this.buergen.set(buerge.unternehmenId, buerge);
      }
    },
    ersetzeBuerge(buerge: Buerge) {
      this.buergen.set(buerge.unternehmenId, buerge);
    },
  },

  getters: {
    getBuergen(state): Buerge[] {
      return Array.from(state.buergen.values());
    },

    getBuergenWithAuftraegeErlaubt(state): Buerge[] {
      return Array.from(state.buergen.values()).filter((buerge) => buerge.erlaubtAuftraege);
    },

    getBuergeById(state): (id: string) => Buerge | undefined {
      return (id: string): Buerge | undefined => state.buergen.get(id);
    },

    getBuergeName(state): (id: string) => string {
      return (id: string): string => state.buergen.get(id).name;
    },
    isLieferkanalPdf(state): boolean {
      const nutzerStore = useNutzerStore();
      return !!state.buergen.get(nutzerStore.nutzer.organisation)?.lieferkanalPdf;
    },
  },
});
